// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed69cfe1","453":"fad9ad8d","455":"19bea065","977":"17842801"}[chunkId] + ".chunk.js";
};